import React from "react";
import { schedule } from "../data/mockData";
import { Calendar, Clock } from "lucide-react";

const Schedule = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Page Header */}
      <div className="bg-blue-950 py-16 text-center">
        <h1 className="mb-4 text-4xl font-extrabold tracking-wider text-white sm:text-5xl md:text-6xl">
          SCHEDULE
        </h1>
        <div className="mx-auto h-1 w-32 bg-blue-600 sm:w-48" />
      </div>

      <div className="mx-auto max-w-6xl px-4 py-12 sm:px-6">
        <div className="mb-12 text-center">
          <p className="text-xl text-gray-700">
            Detailed schedule of TG-SMART 2026 Conference
          </p>
        </div>

        {schedule.map((day) => (
          <section key={day.date} className="mb-12">
            <div className="flex items-center gap-3 rounded-t-xl bg-gradient-to-r from-primary-600 to-primary-700 p-6 text-white">
              <Calendar size={28} />
              <h2 className="text-xl font-bold sm:text-2xl">{day.date}</h2>
            </div>

            <div className="overflow-x-auto rounded-b-xl border-2 border-primary-100 bg-white shadow-xl">
              <table className="w-full min-w-[650px]">
                <thead className="bg-primary-50">
                  <tr>
                    <th className="border-b-2 border-primary-200 p-4 text-left font-bold text-primary-900">
                      Time
                    </th>
                    <th className="border-b-2 border-primary-200 p-4 text-left font-bold text-primary-900">
                      Activity
                    </th>
                    <th className="border-b-2 border-primary-200 p-4 text-left font-bold text-primary-900">
                      Venue
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {day.events.map((event, index) => (
                    <tr
                      key={`${event.time}-${index}`}
                      className={`transition-colors ${
                        event.highlight
                          ? "bg-blue-200 hover:bg-blue-100"
                          : "hover:bg-primary-50"
                      }`}
                    >
                      <td className="border-b border-gray-200 p-4">
                        <div className="flex items-center gap-2 whitespace-nowrap font-semibold text-primary-700">
                          <Clock size={18} className="shrink-0" />
                          {event.time}
                        </div>
                      </td>

                      <td className="border-b border-gray-200 p-4 text-gray-800">
                        <div>{event.activity}</div>
                        {event.topic && (
                          <div className="mt-1">
                            <strong>Topic:</strong> <em>{event.topic}</em>
                          </div>
                        )}
                      </td>

                      <td className="border-b border-gray-200 p-4 text-gray-700">
                        {event.venues ? (
                          <div className="space-y-1">
                            {event.venues.map((venue) => (
                              <div key={venue}>{venue}</div>
                            ))}
                          </div>
                        ) : (
                          event.venue
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>
        ))}

        <div className="rounded-lg border border-blue-200 bg-gradient-to-r from-primary-200 to-primary-300 p-6">
          <p className="text-black">
            <strong>Note:</strong> The schedule is tentative and subject to
            change. Please check back for updates.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Schedule;
